import { useCallback, useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { fmtDate } from "../lib/roles";
import { Empty, Loading, PageHeader, Panel } from "../components/common";

export default function AdminTasks() {
  const [list, setList] = useState(null);
  const load = useCallback(() => api("/admin/tasks").then((d) => setList(d.tasks || [])).catch(() => setList([])), []);
  useEffect(() => { load(); }, [load]);
  const del = async (t) => {
    if (!window.confirm(`Eliminare il compito "${t.titolo}"?`)) return;
    try { await api(`/admin/tasks/${t.id}`, { method: "DELETE" }); toast.success("Compito eliminato"); load(); } catch (e) { toast.error(e.message); }
  };
  if (!list) return <Loading />;
  return (
    <div>
      <PageHeader subtitle="Pannello Direttore" title="Compiti affidati" />
      {list.length === 0 ? <Empty title="Nessun compito assegnato" text="I compiti che assegni compariranno qui." /> : (
        <div className="space-y-3 stagger" data-testid="admin-tasks-list">{list.map((t) => (
          <Panel key={t.id} className="!p-5 flex justify-between gap-4" data-testid={`admin-task-${t.id}`}>
            <div><div className="flex flex-wrap gap-2 items-center"><span className="font-semibold text-[var(--navy)]">{t.titolo}</span>{t.mansione && <span className="tag tag-teal">{t.mansione}</span>}{t.completed && <span className="tag tag-green">Terminato</span>}</div>
              <p className="text-sm text-slate-600 mt-1">{t.descrizione}</p>{t.data_scadenza && <p className="text-xs text-slate-400 mt-2">Scadenza: {fmtDate(t.data_scadenza)}</p>}</div>
            <button onClick={() => del(t)} className="text-slate-400 hover:text-[var(--red)] h-fit" data-testid={`admin-task-delete-${t.id}`}><Trash2 className="w-4 h-4" /></button>
          </Panel>))}
        </div>)}
    </div>
  );
}
